import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useTitle from '../../hooks/useTitle';
import EventsView from './EventsView';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import { Creators as eventPenaltiesActions } from '@/domain/useCases/events/getEventPenaltiesUseCase';
import constants from '../../constants';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';

const EventsViewController = () => {
  useTitle('Eventos');
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentPeriod } = useExternalSettings();

  useEffect(() => {
    GoogleAnalytics.writeLog('portal-services-events', 'services');
    dispatch(eventPenaltiesActions.getEventPenalties(currentPeriod));
    return () => {
      dispatch(eventPenaltiesActions.getEventPenaltiesClear());
    };
  }, []);

  const handleTab = (selected: number) => {
    GoogleAnalytics.writeLog(
      'change-event-tab',
      'ClickKindOfEvents',
      `Selected: ${selected.toString()}`
    );
  };

  const selectEvent = (eventId: number, typeEvent: string) => {
    GoogleAnalytics.writeLog(
      'selected-event',
      'ClickEventCard',
      `EventId: ${eventId}`
    );
    history.push(`/servicios/eventos/${typeEvent}/detalle/${eventId}`);
  };

  const goBackButton = () => {
    GoogleAnalytics.writeLog('back-from-services', 'backbutton');
    history.push('/servicios');
  };

  return (
    <EventsView
      handleTab={handleTab}
      selectEvent={selectEvent}
      goBackButton={goBackButton}
      subsectionHeader={constants.subsectionHeader}
    />
  );
};

export default EventsViewController;
